import validate from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/pages/runtime/validate.js";
import cart_45global from "/builds/connection-ticketing/boats-spa/web-app/middleware/cart.global.ts";
import redirect_45global from "/builds/connection-ticketing/boats-spa/web-app/middleware/redirect.global.ts";
import utm_45global from "/builds/connection-ticketing/boats-spa/web-app/middleware/utm.global.ts";
import manifest_45route_45rule from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  cart_45global,
  redirect_45global,
  utm_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/connection-ticketing/boats-spa/web-app/middleware/auth.ts")
}